// import { h, Component } from 'preact';
import React, { Component } from 'react';
import { HarmonyEvent } from '@spotify-internal/harmony';
import { connect } from 'unistore/full/react';
// import Button from '../Button/Button';
// import PlayButton from '../Button/PlayButton';
import actions from './actions';
import './MiniPlayer.scss';
import getImagesUrlBySize from './get-images-url-by-size';
import AutoScrollingContainer from './AutoScrollingContainer';
import getTypeFromUri from './get-type-from-uri';

const MiniPlayerProgressBar = connect(
  ({ playerState: { duration: trackDuration = 0 } = {}, harmony }) => {
    return {
      harmony,
      trackDuration,
    };
  }
)(
  class MiniPlayerProgressBar extends Component {
    state = {
      trackPosition: 0,
    };

    async componentDidMount() {
      this.props.harmony.on(HarmonyEvent.PROGRESS, this.onProgress);
      this.setState({
        trackPosition:
          ((await this.props.harmony.getCurrentState()) || {}).position || 0,
      });
    }

    componentWillUnmount() {
      this.props.harmony.removeListener(HarmonyEvent.PROGRESS, this.onProgress);
    }

    onProgress = ({ data: { position: trackPosition } } = {}) =>
      this.setState({ trackPosition });

    render() {
      const { trackDuration } = this.props;
      const { trackPosition } = this.state;
      return (
        <div className="MiniPlayerProgressBar">
          <div
            className="MiniPlayerProgressBar__inner"
            style={{
              transform: `scaleX(${trackPosition / trackDuration})`,
              willChange: 'transform',
            }}
          />
        </div>
      );
    }
  }
);

export default connect(
  ({
    contextUri,
    currentRow,
    isMobile,
    nextRows,
    previousRows,
    device,
    playerState: { paused } = {},
    adaptiveSignalByContextUriAndTrackUri,
    playlistsById,
  }) => {
    return {
      isPlaying: !paused && !!contextUri,
      prevTrack:
        previousRows &&
        previousRows[previousRows.length - 1] &&
        previousRows[previousRows.length - 1].track,
      track: currentRow && currentRow.track,
      nextTrack: nextRows && nextRows[0] && nextRows[0].track,
      contextUri,
      isMobile,
      deviceLabel: isMobile && device && device.name,
      currentContextTrackAdaptiveSignal:
        adaptiveSignalByContextUriAndTrackUri?.[contextUri]?.[
          currentRow?.track?.uri
        ],
      isInspiredByMix:
        getTypeFromUri(contextUri) === 'playlist' &&
        playlistsById[contextUri?.substr(-22)]?.format === 'inspiredby-mix',
    };
  },
  actions
)(
  class MiniPlayer extends Component {
    state = {
      x: 0,
      isTransitioning: false,
    };

    componentDidMount() {
      document.addEventListener('pointermove', this.onDocumentPointerMove);
      document.addEventListener('pointerup', this.onDocumentPointerUp);
      document.addEventListener('pointercancel', this.onDocumentPointerCancel);
    }

    componentWillUnmount() {
      document.removeEventListener('pointermove', this.onDocumentPointerMove);
      document.removeEventListener('pointerup', this.onDocumentPointerUp);
      document.addEventListener('pointercancel', this.onDocumentPointerCancel);
    }

    shouldComponentUpdate = () =>
      !this.state.isTransitioning ||
      Date.now() - this.state.lastTransitionAt > 200;

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.track !== this.props.track) {
        this.setState({ x: 0 });
      }
    }

    onPointerDown = (event) => {
      this.isPointerDown = true;
      this.shouldBeTreatedAsClick = true;
      this.pointerDownX = event.nativeEvent.x;
      this.lastPointerMoveX = event.nativeEvent.x;
    };

    onDocumentPointerMove = (event) => {
      if (this.isPointerDown) {
        //&& this.props.opacity > 0.95) {
        const movementX = event.x - this.lastPointerMoveX;
        const x = this.state.x + movementX;

        this.setState({ x });

        this.lastPointerMoveX = event.x;
        this.lastPointerMovementX = movementX;
        if (Math.abs(x) > 5) {
          event.preventDefault();
          event.stopPropagation();
          this.shouldBeTreatedAsClick = false;
        }
      }
    };

    onDocumentPointerUp = (event) => {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;

      const MOVEMENT_THRESHOLD = 5;
      const DIFF_X_THRESHOLD = this.centerElement.offsetWidth / 2;

      let x;
      if (
        this.props.nextTrack &&
        (this.lastPointerMovementX < -MOVEMENT_THRESHOLD ||
          event.x - this.pointerDownX < -DIFF_X_THRESHOLD)
      ) {
        x = '-100%';
        this.props.playNext();
      } else if (
        this.props.prevTrack &&
        (this.lastPointerMovementX > MOVEMENT_THRESHOLD ||
          event.x - this.pointerDownX > DIFF_X_THRESHOLD)
      ) {
        x = '100%';
        this.props.playPrevious();
      } else {
        x = 0;

        if (this.shouldBeTreatedAsClick) this.props.toggleNowPlayingView();
        this.shouldBeTreatedAsClick = null;
      }

      this.setState({
        x,
        isTransitioning: this.state.x !== x,
        lastTransitionAt: Date.now(),
      });
      this.lastPointerMovementX = null;
    };

    onDocumentPointerCancel = (event) => {
      this.isPointerDown = false;
    };

    onTransitionEnd = (event) => {
      this.setState({
        isTransitioning: false,
      });
    };

    onCenterRef = (centerElement) => (this.centerElement = centerElement);

    render() {
      const { track, prevTrack, nextTrack, opacity, isPlaying } = this.props;
      const { x, isTransitioning } = this.state;
      const coverArtImageUrl = getImagesUrlBySize(
        track && track.album && track.album.images,
        54
      );

      const nextCoverArtImageUrl = getImagesUrlBySize(
        nextTrack && nextTrack.album && nextTrack.album.images,
        54
      );
      nextCoverArtImageUrl && (new Image().src = nextCoverArtImageUrl);
      return (
        <div
          className="MiniPlayer"
          style={{
            opacity: opacity,
            // pointerEvents: needsPointerEvents ? 'auto' : 'none'
          }}
        >
          {track && (
            <>
              <MiniPlayerProgressBar />
              <div
                className="MiniPlayer__cover-art"
                style={{
                  backgroundSize: coverArtImageUrl ? 'cover' : 'initial',
                  backgroundImage: coverArtImageUrl
                    ? `url(${coverArtImageUrl})`
                    : `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.2499 6.31706L11.0019 2.13306L11.0129 16.0421C10.3779 15.3981 9.49695 14.9961 8.52295 14.9961C6.59295 14.9961 5.02295 16.5661 5.02295 18.4961C5.02295 20.4261 6.59295 21.9961 8.52295 21.9961C10.3799 21.9961 11.8889 20.5381 12.0019 18.7091C12.0019 18.7091 12.0159 18.4411 12.0149 18.4121L12.0029 3.86606L17.7499 7.18306L18.2499 6.31706ZM8.52295 20.9971C7.14495 20.9971 6.02295 19.8761 6.02295 18.4971C6.02295 17.1191 7.14495 15.9971 8.52295 15.9971C9.87295 15.9971 10.9689 17.0741 11.0139 18.4131V18.5801C10.9699 19.9191 9.87295 20.9971 8.52295 20.9971Z' fill='white'/%3E%3C/svg%3E")`,
                }}
              ></div>

              <div
                className="MiniPlayer__center"
                onPointerDown={this.onPointerDown}
                ref={this.onCenterRef}
              >
                <div
                  className={`MiniPlayer__tracks ${
                    isTransitioning
                      ? 'MiniPlayer__tracks--is-transitioning'
                      : ''
                  }`}
                  style={{
                    transform: `translateX(${x}${
                      typeof x === 'number' ? 'px' : ''
                    })`,
                  }}
                  onTransitionEnd={this.onTransitionEnd}
                >
                  {[
                    {
                      className: 'MiniPlayer__track--previous',
                      track: prevTrack,
                    },
                    {
                      className: 'MiniPlayer__track--current',
                      track,
                    },
                    {
                      className: 'MiniPlayer__track--next',
                      track: nextTrack,
                    },
                  ]
                    .filter(({ track }) => track)
                    .map(
                      (
                        {
                          track: {
                            uri,
                            name,
                            artists: [{ name: artistName } = {}] = [],
                          } = {},
                          className,
                        } = {},
                        i
                      ) => (
                        <MiniPlayerTrackLine
                          key={uri || i}
                          artistName={artistName}
                          className={className}
                          name={name}
                          uri={uri}
                        />
                      )
                    )}
                </div>
                {/* <div className="MiniPlayer__device">
                  <span className="spoticon-spotify-connect-16" />
                  &nbsp;{deviceLabel}
                </div> */}
              </div>

              {this.props.isInspiredByMix && (
                <>
                  <div
                    className="MiniPlayer__thumbs-button"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.props.sendAdaptiveRadioSignal(
                        'dislike',
                        this.props.contextUri,
                        this.props.track?.uri
                      );
                    }}
                  >
                    {this.props.currentContextTrackAdaptiveSignal ===
                    'dislike' ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.0002 6.95131L8.16117 5.10591C6.14617 4.69691 4.67917 6.08791 4.17217 7.55491L1.95017 13.9999C1.62817 14.9339 1.77217 15.9309 2.34517 16.7339C2.91817 17.5379 3.81317 17.9999 4.80117 17.9999H10.1732L9.17017 20.2539C8.76217 21.1709 9.10917 22.2399 9.97917 22.7419C10.3192 22.9389 10.6942 23.0339 11.0662 23.0339C11.6862 23.0339 12.2972 22.7689 12.7232 22.2699L17.0002 17.26V6.95131ZM18.0002 16.9999H21.0002V6.99991L18.0002 6.99911V16.9999Z"
                          fill="white"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.228 6.999L8.16099 5.106C6.14599 4.697 4.67899 6.088 4.17199 7.555L1.94999 14C1.62799 14.934 1.77199 15.931 2.34499 16.734C2.91799 17.538 3.81299 18 4.80099 18H10.173L9.16999 20.254C8.76199 21.171 9.10899 22.24 9.97899 22.742C10.319 22.939 10.694 23.034 11.066 23.034C11.686 23.034 12.297 22.769 12.723 22.27L17.222 17H21V7H17.228V6.999ZM17 9.952V14.983C17 15.463 16.824 15.93 16.503 16.301L11.963 21.62C11.595 22.052 10.971 22.159 10.479 21.875C10.054 21.63 9.88399 21.107 10.084 20.66L11.713 17H4.80099C4.14099 17 3.54299 16.692 3.15999 16.154C2.77699 15.616 2.68099 14.95 2.89599 14.326L5.11799 7.881C5.49899 6.777 6.52599 5.793 7.95899 6.086L17 7.974V9.952ZM19.971 15.971H18.029V8.028H19.971V15.971Z"
                          fill="white"
                        />
                      </svg>
                    )}
                  </div>

                  <div
                    className="MiniPlayer__thumbs-button"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.props.sendAdaptiveRadioSignal(
                        'like',
                        this.props.contextUri,
                        this.props.track?.uri
                      );
                    }}
                  >
                    {this.props.currentContextTrackAdaptiveSignal === 'like' ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.199 6.00096C19.187 6.00096 20.082 6.46196 20.655 7.26596C21.228 8.06996 21.372 9.06596 21.05 9.99996L18.827 16.445C18.383 17.735 17.198 18.967 15.546 18.967C15.319 18.967 15.083 18.943 14.839 18.894L6 17.0486V6.74092L10.277 1.73096C10.958 0.931963 12.113 0.733963 13.021 1.25896C13.89 1.75996 14.238 2.82996 13.83 3.74696L12.826 6.00096H18.199ZM5 7.00096H2V17.001H5V7.00096Z"
                          fill="white"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.655 7.26599C20.082 6.46199 19.187 6.00099 18.199 6.00099H12.826L13.83 3.74699C14.238 2.82999 13.89 1.75999 13.021 1.25899C12.113 0.733992 10.958 0.931992 10.277 1.73099L5.778 7.00099H2V17.001H5.772L14.839 18.894C15.083 18.943 15.319 18.967 15.546 18.967C17.198 18.967 18.383 17.735 18.827 16.445L21.05 9.99999C21.372 9.06599 21.228 8.06999 20.655 7.26599ZM4.971 15.972H3.029V8.02899H4.971V15.972ZM20.105 9.67299L17.882 16.119C17.502 17.223 16.473 18.207 15.041 17.914L6 16.026V14.048V9.01699C6 8.53699 6.176 8.06999 6.498 7.69899L11.038 2.37999C11.407 1.94799 12.03 1.84099 12.522 2.12499C12.947 2.36999 13.116 2.89299 12.917 3.33999L11.287 7.00199H18.2C18.86 7.00199 19.458 7.30999 19.842 7.84799C20.224 8.38399 20.32 9.04999 20.105 9.67299Z"
                          fill="white"
                        />
                      </svg>
                    )}
                  </div>
                </>
              )}

              <div
                className="MiniPlayer__play-button"
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.togglePlayback();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  {isPlaying ? (
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5 3H9V21H5V3ZM15 3H19V21H15V3Z"
                      fill="white"
                    />
                  ) : (
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M6 21l15.589-9L6 3v18z"
                      clipRule="evenodd"
                    ></path>
                  )}
                </svg>
              </div>
            </>
          )}
        </div>
      );
    }
  }
);

const MiniPlayerTrackLine = React.memo(function MiniPlayerTrackLine({
  artistName,
  className,
  name,
  uri,
}) {
  return (
    <AutoScrollingContainer
      className={`MiniPlayer__track no-wrap ${className}`}
    >
      <span className="MiniPlayer__track-name no-wrap">{name}</span>
      &nbsp;{uri && '•'}&nbsp;
      <span className="MiniPlayer__track-artists link-subtle no-wrap">
        {artistName}
      </span>
    </AutoScrollingContainer>
  );
});
